<template>

	<div>
		<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
		<div v-if="!isGettingInitialQuote">
			<div class="row">
				<div class="price-in convert-col col-sm-12 col-md-4 col-lg-4 text-center">
					<h4>Amount for quote</h4>
					<div class="row">
						<div class="col-12">
							<div style="display: block">
								<span class="large-inputs large-inputs-fiat">{{ $gstate.getCurrencySymbol(pq.fiatCurrency) }}{{ pq.fiatAmount | num2decimal }}&nbsp;<span class="large-inputs-suffix">{{ pq.fiatCurrency }}</span></span>
							</div>
							<div>
								<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
							</div>
						</div>
					</div>				
				</div>
				<div class="convert-col col-sm-12 col-md-4 col-lg-4 text-center">
					<div class="convert-icon mb-2" alt="Convert"></div>
					<p>
						<span>{{ $gstate.getCurrencySymbol(pq.fiatCurrency) }}1 {{ pq.fiatCurrency }} = {{ ( pq.cryptoAmount / parseFloat(pq.fiatAmount) ) | num8decimal }}&nbsp;{{ pq.cryptoCurrency }}</span><br>
						<span style="font-size: 10px;">{{ getFeeMsg }}</span>
					</p>
				</div>
				<div class="crypto-out convert-col col-sm-12 col-md-4 col-lg-4 text-center">
					<h4>You will receive</h4>
					<div class="row">
						<div class="col-12">
							<div style="display: block">
								<span class="large-inputs large-inputs-crypto">~{{ pq.cryptoAmount | num8decimal }}&nbsp;<span class="large-inputs-suffix">{{ pq.cryptoCurrency }}</span></span>
							</div>
							<div>
								<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row mb-4 mt-0 pb-2">
				<div class="col-12 text-left col-md-8 offset-md-2 pt-3 pr-4 pl-4 pb-1 text-center mb-0">
					<p><small>{{ ccMsg }}<br />Amount is only an estimate and may change upon final checkout.</small></p>
					<hr class="mt-4">
				</div>

				<div class="col-12 col-md-4 offset-md-4 text-center">
					<p>By continuing, you agree and consent to the <a target="_blank" v-bind:href="tosURL">Terms of Service</a> and <a target="_blank" v-bind:href="ppURL">Privacy Policy</a></p>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center">
					<a href="#" id="price-quote-next" class="btn next-btn" ref="btnNext" :class="{'disabled' : isProcessing }" v-on:click.prevent="next">NEXT</a>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center new-quote">
					<!--
					<a href="#" v-if="!isProcessingRequote" :class="{'disabled' : isProcessing }" v-on:click.prevent="getNewQuote">Refresh quote</a>
					<a href="#" class="disabled" v-if="isProcessingRequote" v-on:click.prevent="noop">Please wait... <i class="fas fa-circle-notch fa-spin"></i></a>
					-->
					<small class="error" v-if="hasError">{{errorMessage}}</small>
				</div>
			</div>
		</div>
		</transition>
		<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
		<div v-if="isGettingInitialQuote" class="vertical-center getting-quote">
			<div class="container main-content">
				<div class="row text-center">
					<div class="col-12">
						<template v-if="!hasError">
							Verifying... <i class="fas fa-circle-notch fa-spin"></i>
						</template>
						<template v-else>
							{{ errorMessage }}
						</template>
					</div>
				</div>
			</div>
		</div>
		</transition>
	</div>

</template>

<script>

import { eventBus } from './../main'

export default {
	mounted() {

	},
	data() {
		return {
			hasError: false,
			isProcessing: false,
			isProcessingRequote: false,
			isGettingInitialQuote: true,
			moonpayFee: 0,
			coincurveFee: 0,
			pq: this.$gstate.getFlowState()
		}
	},
	created(){
		eventBus.$on('nextScreen', this.next);

		this.getQuote();
		
	},
	beforeDestroy(){
		eventBus.$off('nextScreen', this.next);
	},
	computed:{
		tosURL: function() {

			var urlstr = this.$gstate.getSiteURL() + '/terms-of-service';
			if(!this.$gstate.isCoincurve()){
				urlstr = "/#/terms-of-service";
			}

			return urlstr;
			
		},
		ppURL: function() {
			
			var urlstr = this.$gstate.getSiteURL() + '/privacy-policy';
			if(!this.$gstate.isCoincurve()){
				urlstr = "/#/privacy-policy";
			}

			return urlstr;
		},
		getFeeMsg: function() {
			return "(transaction fee not included)";
		},
		getFeeTotal(){
			// parse to 2 decimal places
			var parts = Number.parseFloat(this.moonpayFee + this.coincurveFee).toFixed(2).toString().split(".");
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			return parts.join(".");
		},
		ccMsg: function() {

			var str = "";
			str = "You must be a resident of Canada to use " + this.$gstate.getMerchantName() + ".";

			return str;
			
		}
	},
	methods: {
		next: function() {
			this.$router.push('/credit-card');
		},
		getQuote(){
			this.isProcessing = true;

			var urlstr = 	"https://api.moonpay.io/v3/currencies/" + this.pq.cryptoCurrency.toString().toLowerCase() + "/quote/"
							 + "?apiKey=" + this.$gstate.getMoonpayApiKey()
							 + "&baseCurrencyCode=" + this.pq.fiatCurrency.toString().toLowerCase()
							 + "&baseCurrencyAmount=" + this.pq.fiatAmount;

			this.axios.get(urlstr)
				.then(response => {

					this.isGettingInitialQuote = false;
					this.isProcessing = false;
					this.isProcessingRequote = false;
					this.pq.cryptoAmount = response.data.quoteCurrencyAmount;
					this.moonpayFee = response.data.feeAmount;

					if(response.data.extraFeeAmount != undefined){
						this.coincurveFee = response.data.extraFeeAmount;
					}

				})
				.catch(error => {
					this.hasError = true;
					this.errorMessage = "It looks we're having issues.  Our team has been notified.  Please try again later."
					this.$gstate.log(error);
					
				});

		},
		getNewQuote(){
			this.isProcessingRequote = true;
			this.getQuote();
		}
		
	}
}
</script>
